<table class="itsl-course-enrollment-course-info__table">
    <caption>{i18n.course_information}</caption>
    <tr>
        <th>
            {i18n.title}
        </th>
        <td>
            {courseTitle}
        </td>
    </tr>
    <tr>
        <th>
            {i18n.registration}
        </th>
        <td>
            {registration}
        </td>
    </tr>
    <tr>
        <th>
            {adminRowHeader}
        </th>
        <td>
            <slot name="administrators"></slot>
        </td>
    </tr>
    <tr>
        <th>
            {i18n.course_information_Learning_location}
        </th>
        <td>
            {location}
        </td>
    </tr>
    <tr>
        <th>
            {i18n.credits}
        </th>
        <td>
            {credits}
        </td>
    </tr>
    <tr>
        <th>
            {i18n.course_code}
        </th>
        <td>
            {courseCode}
        </td>
    </tr>
    <tr>
        <th>
            {i18n.content}
        </th>
        <td>
            {content}
        </td>
    </tr>
    <tr>
        <th>
            {i18n.objective}
        </th>
        <td>
            {objective}
        </td>
    </tr>
    <tr>
        <th>
            {i18n.organisation}
        </th>
        <td>
            {organisation}
        </td>
    </tr>
    <tr>
        <th>
            {i18n.evaluation}
        </th>
        <td>
            {evaluation}
        </td>
    </tr>
    <tr>
        <th>
            {i18n.course_information_Free_spots}
        </th>
        <td>
            {#if numberOfFreeSeats !== null}
                <div aria-hidden="true">{`${numberOfFreeSeats} / ${maxAllowedNumberOfSeats}`}</div>
                <div class="itsl-course-enrollment-course-info__number-of-free-seats">
                    {formatLanguageString(
                        i18n.test_x_of_y,
                        numberOfFreeSeats,
                        maxAllowedNumberOfSeats)}
                </div>
            {:else}
                {i18n.course_information_Free_spots_not_stated}
            {/if}
        </td>
    </tr>
</table>

<script>
    import { formatLanguageString } from '@itslearning/atlas/strings/format.js';
    import { courseEnrollmentMode } from '../../constants';

    export let enrollMode = -1;
    export let courseTitle = '';
    export let courseCode = '';
    export let courseAdministrators = [];
    export let location = '';
    export let credits = '';
    export let content = '';
    export let objective = '';
    export let organisation = '';
    export let evaluation = '';
    export let numberOfFreeSeats = null;
    export let maxAllowedNumberOfSeats = null;
    export let i18n = {};

    let registration = '';

    $: {
        switch (enrollMode) {
            case courseEnrollmentMode.standard: {
                registration = i18n.course_information_Enrollment_mode_standard;
                break;
            }
            case courseEnrollmentMode.supervised: {
                registration = i18n.extension_Application;
                break;
            }
            case courseEnrollmentMode.free: {
                registration = i18n.course_information_Enrollment_mode_free;
                break;
            }
            case courseEnrollmentMode.password: {
                registration = i18n.course_information_Enrollment_mode_password;
                break;
            }
            default:
                registration = '';
                break;
        }
    }

    $: adminRowHeader = formatLanguageString(i18n.course_information_Course_administrator_X, courseAdministrators.length);
</script>